/**
 * Perception rating items for stimulus perception checks.
 *
 * Two item sets: one for standalone posts, one for post+comment pairs.
 * Dimensions map to the 2×3 experimental design:
 *   - Emotionality / Rationality → complexity dimension
 *   - Group targeting / Ingroup solidarity / Outgroup hostility → attribution dimension
 *   - Authenticity → general validity
 *   - Engagement quality → comment-specific (addresses the OP-engagement concern)
 */

const POST_PERCEPTION_ITEMS = [
  {
    itemId: "emotionality",
    text: "This post communicates in an emotional way.",
  },
  {
    itemId: "rationality",
    text: "This post presents logical arguments or evidence.",
  },
  {
    itemId: "group_targeting",
    text: "This post references or targets specific groups of people.",
  },
  {
    itemId: "ingroup_solidarity",
    text: "This post expresses solidarity with like-minded people.",
  },
  {
    itemId: "outgroup_hostility",
    text: "This post is dismissive or hostile toward people with opposing views.",
  },
  {
    itemId: "authenticity",
    text: "This post seems like something a real person would write on social media.",
  },
];

const COMMENT_PERCEPTION_ITEMS = [
  ...POST_PERCEPTION_ITEMS.map((item) => ({
    ...item,
    // Relabel to refer to "comment" instead of "post"
    text: item.text.replace(/This post/g, "This comment"),
  })),
  {
    itemId: "engagement_quality",
    text: "This comment meaningfully engages with the original post.",
  },
];

const PERCEPTION_SCALE = {
  points: 7,
  labels: [
    "Strongly disagree",
    "Disagree",
    "Somewhat disagree",
    "Neutral",
    "Somewhat agree",
    "Agree",
    "Strongly agree",
  ],
};

module.exports = {
  POST_PERCEPTION_ITEMS,
  COMMENT_PERCEPTION_ITEMS,
  PERCEPTION_SCALE,
};
